import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "../components/ModuleHeader";
import DateDropdown from "@/components/DateDropdown";
import { lcgApi } from "@/api/lcgApi";
import moment from "moment";
// 颜色插值函数
const lerpColor = (start, end, t) => {
    const hexToRgb = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return [r, g, b];
    };
    const [r1, g1, b1] = hexToRgb(start);
    const [r2, g2, b2] = hexToRgb(end);
    const r = Math.round(r1 + (r2 - r1) * t);
    const g = Math.round(g1 + (g2 - g1) * t);
    const b = Math.round(b1 + (b2 - b1) * t);
    return `rgb(${r}, ${g}, ${b})`;
};
// 核心配置（scrollSpeed将直接生效）
const config = {
    totalBlocks: 40,
    blockHeight: "0.16rem",
    blockGap: 0.02,
    filledColor: "#00E6F0",
    gradientEnd: "#B3F9FF",
    emptyColor: "#2A3A4E",
    titleWidth: "0.8rem",
    itemMarginTop: 0.3,
    scrollSpeed: 1, // 每次滚动的像素数（改这个值会直接生效）
    scrollInterval: 30, // 滚动间隔（毫秒），值越小滚动越流畅
};
const UsageRanking = ({ className = "" }) => {
    const scrollContainerRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const scrollTimerRef = useRef(null);
    const [initDate, setSelectedDate] = useState(moment().format("YYYY-MM"));
    const [progressData, setDatasource] = useState([]);
    useEffect(() => {
        getData(initDate);
    }, [initDate]);
    /**
     * @description: getData - 获取数据
     */
    const getData = async (date) => {
        try {
            const res = await lcgApi.ranks({ month: initDate });
            setDatasource([
                {
                    stockId: "1969343217032986625",
                    mname: "[AOC]显示器 U27P2C 27英寸台",
                    spec: "U27P2C 27英寸台",
                    mdeptName: "综合管理部",
                    useQty: 121,
                },
                {
                    stockId: "1969647023130116012",
                    mname: "饮水机",
                    mdeptName: "综合管理部",
                    useQty: 5,
                },
                {
                    stockId: "1969647023130116091",
                    mname: "办公桌",
                    mdeptName: "综合管理部",
                    useQty: 1,
                },
                {
                    stockId: "1969647023130116098",
                    mname: "打印机",
                    mdeptName: "综合管理部",
                    useQty: 5,
                },
                {
                    stockId: "1969647023130116091",
                    mname: "空气净化器",
                    mdeptName: "综合管理部",
                    useQty: 8,
                },
                {
                    stockId: "1969699482917740545",
                    mname: "加湿器",
                    spec: "0.6*0.7*1m",
                    mdeptName: "综合管理部",
                    useQty: 10,
                },
                {
                    stockId: "19693432361296d52738",
                    mname: "科大讯飞 X3Pro 10.65英寸电子办公本 墨水屏 黑色(台)",
                    spec: "X3Pro 10.65英寸电子办公本",
                    mdeptName: "综合管理部",
                    useQty: 28,
                },
            ]);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    const handleChangeDate = async (date) => {
        setSelectedDate(date);
    };
    //改用setInterval实现滚动（确保scrollSpeed参数有效）
    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container)
            return;
        // 启动滚动定时器
        const startScroll = () => {
            // 清除已有定时器
            if (scrollTimerRef.current) {
                clearInterval(scrollTimerRef.current);
            }
            scrollTimerRef.current = setInterval(() => {
                if (!isPaused && container) {
                    // 直接使用scrollSpeed作为每次滚动的像素数（参数将直接生效）
                    container.scrollTop += config.scrollSpeed;
                    // 检测是否滚动到底部
                    if (container.scrollTop + container.clientHeight >=
                        container.scrollHeight - 5) {
                        container.scrollTop = 0; // 回到顶部
                        setIsPaused(true);
                        setTimeout(() => setIsPaused(false), 3000); // 暂停3秒后继续
                    }
                }
            }, config.scrollInterval);
        };
        // 初始化启动滚动
        startScroll();
        // 组件卸载时清理定时器
        return () => {
            if (scrollTimerRef.current) {
                clearInterval(scrollTimerRef.current);
            }
        };
    }, [isPaused]);
    //当isPaused状态变化时重启定时器
    useEffect(() => {
        if (scrollContainerRef.current) {
            if (!isPaused) {
                // 恢复滚动
                if (scrollTimerRef.current) {
                    clearInterval(scrollTimerRef.current);
                }
                scrollTimerRef.current = setInterval(() => {
                    const container = scrollContainerRef.current;
                    if (container) {
                        container.scrollTop += config.scrollSpeed;
                        if (container.scrollTop + container.clientHeight >=
                            container.scrollHeight - 5) {
                            container.scrollTop = 0;
                            setIsPaused(true);
                            setTimeout(() => setIsPaused(false), 3000);
                        }
                    }
                }, config.scrollInterval);
            }
            else {
                // 暂停滚动
                if (scrollTimerRef.current) {
                    clearInterval(scrollTimerRef.current);
                }
            }
        }
    }, [isPaused]);
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.2)]
        min-h-0
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u4F4E\u8017\u9886\u7528\u6392\u884C\u699C", children: _jsx(DateDropdown, { initDate: initDate, onDateChange: (date) => handleChangeDate(date) }) }), _jsx("div", { ref: scrollContainerRef, className: "flex-1 text-white overflow-hidden overflow-y-auto min-h-0", style: {
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    paddingLeft: "0.1rem",
                    paddingRight: "0.1rem",
                }, onMouseEnter: () => setIsPaused(true), onMouseLeave: () => setIsPaused(false), children: _jsx("div", { className: "h-[0.4rem]", children: progressData.map((item, index) => {
                        const filledRatio = (item.useQty / 200) * config.totalBlocks;
                        const isLastItem = index === progressData.length - 1;
                        const isAlmostFull = filledRatio > config.totalBlocks - 5;
                        return (_jsxs("div", { className: "flex items-center h-[0.4rem]", children: [_jsx("div", { className: "text-left font-medium", style: {
                                        width: config.titleWidth,
                                        fontSize: "0.16rem",
                                        whiteSpace: "nowrap", // 不换行
                                        overflow: "hidden", // 超出隐藏
                                        textOverflow: "ellipsis", // 显示省略号
                                    }, children: item.mname }), _jsxs("div", { className: "flex-1 mx-[0.02rem] h-[0.16rem] relative", style: {
                                        display: "grid",
                                        gridTemplateColumns: `repeat(${config.totalBlocks}, 1fr)`,
                                        gridGap: `${config.blockGap}rem`,
                                        height: config.blockHeight,
                                    }, children: [Array.from({ length: config.totalBlocks }).map((_, blockIndex) => {
                                            const isFilled = blockIndex < filledRatio;
                                            let bgColor = config.emptyColor;
                                            if (isFilled) {
                                                const gradientPos = blockIndex / (config.totalBlocks - 1);
                                                bgColor = lerpColor(config.filledColor, config.gradientEnd, gradientPos);
                                            }
                                            return (_jsx("div", { style: { backgroundColor: bgColor, borderRadius: 0 } }, blockIndex));
                                        }), _jsx("span", { style: {
                                                position: "absolute",
                                                left: `${(filledRatio / config.totalBlocks) * 100}%`,
                                                transform: `translate(${isAlmostFull ? -0.3 : 0.05}rem, 0%)`,
                                                color: "#00E6F0",
                                                fontSize: "0.12rem",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden", // 超出隐藏
                                                textOverflow: "ellipsis", // 显示省略号
                                                maxWidth: "3rem", // 限制最大宽度
                                                fontWeight: "bold",
                                                textShadow: "0 0 0.02rem rgba(0,0,0,0.6)",
                                            }, children: item.useQty })] })] }, `${item.mname}-${index}`));
                    }) }) })] }));
};
export default UsageRanking;
